import React from "react";
import size from "lodash/size";

import { Box, Stack, Typography } from "@mui/material";

import { VehicleFeature } from "types";
import { FeatureItem } from ".";

type GeneralFeaturesProps = {
  features: VehicleFeature[];
  hasTripConflict: boolean;
};

function GeneralFeatures(props: GeneralFeaturesProps) {
  const { features, hasTripConflict } = props;

  return (
    <Box>
      <Typography variant="overline">General</Typography>

      <Box display="flex" flexDirection="row" mt={1.5}>
        {!size(features) && "-"}

        {/* row 1 */}
        <Stack spacing={1.5} justifyContent="flex-start" mr={0.5}>
          {features.slice(0, 5).map(({ id, name }) => (
            <Box key={id}>
              <FeatureItem name={name} hasTripConflict={hasTripConflict} />
            </Box>
          ))}
        </Stack>

        {/* row 2 */}
        <Stack spacing={1.5} justifyContent="flex-start">
          {features.slice(5).map(({ id, name }) => (
            <Box key={id}>
              <FeatureItem name={name} hasTripConflict={hasTripConflict} />
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}

export default GeneralFeatures;
